export const navbarRoutes = [
    { label: 'Home', path: '/'},
    { label: 'Projects', path: '/projects'},
    { label: 'Payment', path: '/pricing'},
    { label: 'Contact Us', path: '/contact'},
]